<template>
  <TextInput
    v-model="value"
    :placeholder="$t('components.inputs.type_to_search')"
    ref="inputRef"
    size="md"
  >
    <template #start>
      <Icon name="search" class="fg-quaternary" />
    </template>
    <template #end>
      <Icon
        v-if="!isEmpty(modelValue)"
        name="close"
        size="sm"
        class="cursor-pointer fg-quaternary"
        @click="value = ''"
      />
    </template>
  </TextInput>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { debounce as debounceFn } from "vue-debounce";
import { isEmpty } from "lodash";
import { Icon } from "@/SharedComponents/Icon";
import { TextInput } from "@/SharedComponents/Inputs";

const inputRef = ref(undefined);

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: { type: String, required: false },
  debounce: { type: Number, default: 400 },
});

const value = ref(props.modelValue);

watch(
  value,
  debounceFn((newValue) => {
    emit("update:modelValue", newValue);
  }, props.debounce)
);

onMounted(() => {
  inputRef.value?.focus();
});
</script>
